export default __webpack_public_path__ + "static/media/rate-room.9b78a011.svg";